import { useState, FC } from 'react';
import Alert from '@mui/material/Alert';
import { useSnackbar } from 'notistack';
import { Box, Fade, ButtonGroup, Button, Typography } from '@mui/material';
import { Close, Restore } from '@mui/icons-material';
import { Modal, Loader } from '../../../components';
import { IBuild } from '../../../models';
import { convertBuildToSpec } from '../../../fetch';

interface IConvertBuildModal {
  currentBuild: IBuild;
  open: boolean;
  onClose: () => void;
  fetchBuilds: () => void;
}

export const ConvertBuildModal: FC<IConvertBuildModal> = ({
  open,
  onClose,
  currentBuild,
  fetchBuilds
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isConverting, setConverting] = useState(false);
  return (
    <Modal open={open} onClose={onClose} maxWidth="sm">
      <Fade in={open}>
        <div>
          {isConverting && (
            <Loader position="centered" type="overlay">
              Converting...
            </Loader>
          )}
          <Box marginBottom="1rem">
            {currentBuild && (
              <Typography variant="h5">
                Converting Build {currentBuild.neighborhood} - Lot {currentBuild.lotNumber}{' '}
                {currentBuild && currentBuild.status ? `- ${currentBuild.status}` : ''}{' '}
                {currentBuild && currentBuild.buyer ? `- ${currentBuild.buyer}` : ''}
              </Typography>
            )}
          </Box>
          <Alert severity="warning">
            This function will convert an existing build into a Spec home. All purchaser specific
            documents will be deleted.
          </Alert>
          <Box mt={1} display="flex" alignItems="center" justifyContent="flex-end">
            <ButtonGroup>
              <Button
                variant="contained"
                color="primary"
                disabled={isConverting}
                startIcon={<Restore />}
                onClick={async () => {
                  setConverting(true);
                  try {
                    await convertBuildToSpec(currentBuild.buildId);
                    enqueueSnackbar(`Build converted to a spec successfully!`, {
                      variant: 'success'
                    });
                    onClose();
                    fetchBuilds();
                  } catch (error) {
                    enqueueSnackbar(
                      error?.Detail ?? 'Error converting build to spec, please try again.',
                      {
                        variant: 'error'
                      }
                    );
                  } finally {
                    setConverting(false);
                  }
                }}
              >
                Convert
              </Button>
              <Button color="inherit" variant="contained" startIcon={<Close />} onClick={onClose}>
                Cancel
              </Button>
            </ButtonGroup>
          </Box>
        </div>
      </Fade>
    </Modal>
  );
};
